<template>
    <div class="team-tab">
        <h2 class="page-title">Reports</h2>
        <ErrorDisplay/>
        <b-row>
          <b-col xl="12" xs="12">
              <section class="circle-list-panel">
                  <div class="info-section mb-2">
                      <div class="row" v-if="arBreakdown && overviewData && breakdownData">
                          <div class="col-sm-4">
                              <b-card  class="background-cover">
                                  <h5 class="fw-semi-bold">Accounts Receivable Overview</h5>
                                  <h6 class="fw-semi-bold">Total: {{arBreakdown.BalTotal | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</h6>
                                    <div class="chart-panel">
                                      <!-- <AgingDonutChart v-if="this.overviewData" :chartId="1" :donutData="this.overviewData" :colors="colors"></AgingDonutChart> -->
                                      <PieChart v-if="overviewData" :chartdata="overviewData" :options="pieChartOptions" :styles="pieChartStyles" :key="1"/>
                                    </div>
                              </b-card>
                          </div>
                          <div class="col-sm-4">
                              <b-card  class="background-cover">
                                  <h5 class="fw-semi-bold">Accounts Receivable Breakdown</h5>
                                  <h6 class="fw-semi-bold">Ins Write-off: {{arBreakdown.InsWoEst | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</h6>
                                    <div class="chart-panel">
                                      <!-- <AgingDonutChart :chartId="2" :donutData="outStandingClaimsData" :colors="colors"></AgingDonutChart> -->
                                      <PieChart v-if="breakdownData" :chartdata="breakdownData" :options="pieChartOptions" :styles="pieChartStyles" :key="1"/>
                                    </div>
                                    <!--
                                      <div class="text-panel border-top">
                                        <div class="row">
                                          <div class="col-sm-4 p-2 text-center border-right">
                                            <h6 class="text-success fw-semi-bold mt-2 mb-1">Outstanding amount</h6>
                                            <p class="mb-0 fw-semi-bold" style="color: rgb(68, 68, 68);">***Change here</p>
                                          </div>
                                          <div class="col-sm-4 p-2 text-center border-right">
                                              <h6 class="text-success fw-semi-bold mt-2 mb-1">Estimated Ins. Payment</h6>
                                              <p class="mb-0 fw-semi-bold" style="color: rgb(68, 68, 68);">***Change here2</p>
                                            </div>
                                            <div class="col-sm-4 p-2 text-center">
                                                <h6 class="text-success fw-semi-bold mt-2 mb-1">Claims outstanding</h6>
                                                <p class="mb-0 fw-semi-bold" style="color: rgb(68, 68, 68);">*** change here</p>
                                            </div>
                                          </div>
                                    </div>
                                    -->
                              </b-card>
                          </div>
                          <div class="col-sm-4">
                              <!--
                              <b-card  class="background-cover">
                                  <h6 class="mt-1">Outstanding PreAuthorizations</h6>
                                    <div class="chart-panel">
                                      <AgingDonutChart :chartId="3" :donutData="outStandingClaimsData" :colors="colors"></AgingDonutChart>
                                    </div>
                                    <div class="text-panel border-top">
                                        <div class="row">
                                          <div class="col-sm-6 p-2 text-center border-right">
                                            <h6 class="text-success fw-semi-bold mt-2 mb-1">Outstanding in last 30 days</h6>
                                            <p class="mb-0 fw-semi-bold" style="color: rgb(68, 68, 68);">6</p>
                                          </div>
                                          <div class="col-sm-6 p-2 text-center">
                                              <h6 class="text-success fw-semi-bold mt-2 mb-1">Total outstanding</h6>
                                              <p class="mb-0 fw-semi-bold" style="color: rgb(68, 68, 68);"> 18</p>
                                            </div>
                                          </div>
                                    </div>
                              </b-card>
                              -->
                              <b-card class="border-0 unscheduled-treatment-card-wrap" v-if="dataToDisplay">
                                <h5 class=" fw-semi-bold">Outstanding Claims</h5>
                                
                                <b-row align-h="start" align-v="center">
                                  <b-col xs="3" md="3" lg="3">
                                    <p class="h5 fw-semi-bold text-right">{{this.outstandingClaimsData.length}}</p>
                                  </b-col>
                                  <b-col xs="9" md="9" lg="9">
                                    <p class="h6 text-muted fw-semi-bold">total</p>
                                  </b-col>
                                </b-row>
                                <b-row align-h="start" align-v="center">
                                  <b-col xs="3" md="3" lg="3">
                                    <p class="h5 fw-semi-bold text-right">{{this.outstandingClaimsDataMoreThan30DaysOld.length}}</p>
                                  </b-col>
                                  <b-col xs="9" md="9" lg="9">
                                    <p class="h6 text-muted fw-semi-bold">> 30 days old</p>
                                  </b-col>
                                </b-row>
                                <hr/>
                                

                                <h5 class="mb-xl fw-semi-bold">Outstanding Pre-Authorizations</h5>
                                
                                <b-row align-h="start" align-v="center">
                                  <b-col xs="3" md="3" lg="3">
                                    <p class="h5 fw-semi-bold text-right">{{this.outstandingPreAuthData.length}}</p>
                                  </b-col>
                                  <b-col xs="9" md="9" lg="9">
                                    <p class="h6 text-muted fw-semi-bold">total</p>
                                  </b-col>
                                </b-row>
                                <b-row align-h="start" align-v="center">
                                  <b-col xs="3" md="3" lg="3">
                                    <p class="h5 fw-semi-bold text-right">{{this.outstandingPreAuthDataMoreThan30DaysOld.length}}</p>
                                  </b-col>
                                  <b-col xs="9" md="9" lg="9">
                                    <p class="h6 text-muted fw-semi-bold">> 30 days old</p>
                                  </b-col>
                                </b-row>
                                <hr/>

                                <h5 class="mb-xl fw-semi-bold">Received Pre-Authorizations</h5>
                                
                                <b-row align-h="start" align-v="center">
                                  <b-col xs="3" md="3" lg="3">
                                    <p class="h5 fw-semi-bold text-right">{{this.processedPreAuthData.length}}</p>
                                  </b-col>
                                  <b-col xs="9" md="9" lg="9">
                                    <p class="h6 text-muted fw-semi-bold">total</p>
                                  </b-col>
                                </b-row>                                
                              </b-card>
                          </div>
                      </div>
                  </div>
                  <div>
                      <b>More reports coming soon...</b>
                  </div>
              </section> 
            </b-col>
        </b-row>
    </div>
</template>

<script>
/* eslint-disable */

import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import { mapState, mapActions, mapMutations } from 'vuex';
import AgingDonutChart from "./components/MorrisDonutChart";
import PieChart from '@/pages/TeamInsights/components/InsightPieChart';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import moment from 'moment-timezone';
import mixin from '../../mixin.js';
import truncate from 'vue-truncate-collapsed';
import AdminTable from '@/pages/Admin/AdminTable';

export default {
  name: "Reports",
  components: { AgingDonutChart, PieChart, DatePicker, ErrorDisplay, Multiselect, truncate, AdminTable },
  props: ['list'],
  mixins: [mixin],

  created() {
    this.init();
  },

  mounted() {
  },

  data() {
    return {
        results: [],
        pieChartOptions: {
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            },
            legend: {
                display: true,
                position: window.innerWidth < 1400 ? 'bottom' : 'right',
                fullWidth: true,
                labels:{
                padding: 10,
                boxWidth: 15,
                labelWidth: 10
                // margin: 10
                }
            },
            tooltips: {
                callbacks: {
                label: function(tooltipItem, data) {              
                    // https://www.chartjs.org/docs/latest/configuration/tooltip.html#label-callback
                    var label = data.labels[tooltipItem.index] + ': $' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return label;
                }
                }
            },
        responsive: true,
        maintainAspectRatio: false
        }
    }
  },

    methods: {
    ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored', 'setMessage']),
    ...mapActions('teamio', ['runQuery']),
    ...mapActions('lists',['createList']),
    ...mapMutations('teamio', ['emptyResults']),
    ...mapMutations('lists', ['setList']),

        async init() {
        let query = {
            type: 'REPORTS',
            _date: moment().format('YYYY-MM-DD'),
            siteID: this.siteID,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            preAuthOlderThan: this.preAuthOlderThan,
            agingOlderThan: this.agingOlderThan,
            };

            this.emptyResults();
            this.results = await this.runQuery(query);
        }
    },

    computed: {
        ...mapState({
            _list: state => state.lists.list,
        }),

        pieChartStyles() {
            return {
                width: '100%',
                height: window.innerWidth < 1400 ? '180px' :  '150px',
            }
        },

        dataToDisplay() {
          if(this.results && this.results.data && this.results.data.length > 0)
            return this.results.data;
        },

        outstandingClaimsData() {
            if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[1]) {       
                return this.dataToDisplay[1];
            }
        },

        outstandingClaimsDataMoreThan30DaysOld() {
            if(this.outstandingClaimsData)
                return this.outstandingClaimsData.filter(a => moment(a.DateSent).isBefore(moment().subtract(30, 'days'), 'day'));
        },

        outstandingPreAuthData() {
            if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[2]) {
                //preAuthOlderThan
                // return this.dataToDisplay[3].filter(r => r.)
                return this.dataToDisplay[2];
            }
        },

        outstandingPreAuthDataMoreThan30DaysOld() {
            if(this.outstandingPreAuthData)
                return this.outstandingPreAuthData.filter(a => moment(a.DateSent).isBefore(moment().subtract(30, 'days'), 'day'));
        },

        processedPreAuthData() {
            if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[3]) {
                return this.dataToDisplay[3];
            }
        },

        arOverview() {
            if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[0].length > 0) {
                return _.pick(
                  this.dataToDisplay[0][0],
                  [
                      '0-30 DAYS', '31-60 DAYS', '61-90 DAYS', 'OVER 90 DAYS'
                  ]
                )
            }
        },

        arBreakdown() {
            if(this.dataToDisplay && this.dataToDisplay.length > 0 && this.dataToDisplay[0].length > 0) {
                return _.pick(
                this.dataToDisplay[0][0],
                [
                    'BalTotal', 'InsPayEst', 'InsWoEst'
                ]
                )
            }
        },

        arBreakdown2() {
            if(this.arBreakdown) {
                return {
                'Estimated Insurance Payment' : this.arBreakdown['InsPayEst'],
                'Patient Balance': (this.arBreakdown['BalTotal'] - this.arBreakdown['InsWoEst'] - this.arBreakdown['InsPayEst']).toFixed(2)
                }  
            }
        },

        overviewData() {
            if(this.arOverview) {
                return {
                labels: _.keys(this.arOverview),
                datasets: [
                    {
                    label: "Data One",
                    //backgroundColor: ["#41B883", "#00D8FF", "#ff0000", "#ec7609", "#dee41b"],
                    backgroundColor: ["#AAF0D1", "#FFDA77", "#FFA45B", "#D51D48"],

                    data: _.values(this.arOverview)
                    }
                ]
                }
            }
        },

        breakdownData() {
            if(this.arBreakdown) {
                return {
                labels: _.keys(this.arBreakdown2),
                datasets: [
                    {
                        label: "Data One",
                        //backgroundColor: ["#41B883", "#00D8FF", "#ff0000", "#ec7609", "#dee41b"],
                        backgroundColor: ["#AAF0D1", "#FFDA77", "#FFA45B", "#D51D48"],
                        data: _.values(this.arBreakdown2)
                    }
                ]
                }
            }
        },
    }
}

</script>

<style src="./Reports.scss" lang="scss" />